import React, { useState } from "react";
import { FieldArray, Formik } from "formik";
import Swal from "sweetalert2";
import * as yup from "yup";
import { Table } from "react-bootstrap";
import {
  FormArrayDateField,
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import { Accordion, AccordionTab } from "primereact/accordion";
import Illustration from "../../../../../partials/content/Illustration";
import { DialogActions, InputAdornment } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchItem from "../../items/searchItem";
import SetBatchVariantValue from "./setBatchVariantValue";
import SearchItemUom from "../../items/searchItemUom";
import SearchWarehouseStocks from "../../warehouses/searchWarehouseStocks";
import { saveItemsMovement } from "../../../../../services/inventory/itemsMovement";
import { DateTime } from "luxon";
const itemsMovementSchema = yup.object().shape({
  itemsMovement: yup
    .array()
    .of(
      yup.object().shape({
        itemName: yup.string(),
        qty: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Quantity is required")
          .moreThan(0, "Quantity cannot be zero or empty")
          .default(0),
        productionDate: yup
          .date()
          .nullable()
          .max(
            yup.ref("expiryDate"),
            "Production Date must be less equal to Expiry Date"
          ),
        expiryDate: yup
          .date()
          .nullable()
          .min(
            yup.ref("productionDate"),
            "Expiry Date must be greater equal to Production Date"
          ),
        uomName: yup.string().required("Unit is required"),
      })
    )
    .required(),
});
function ItemsMovementForm({
  warehouseID = 0,
  outletID = 0,
  onConfirmSave,
  onCloseDialog,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  let itemsMovementData = {
    moveDate: DateTime.now().startOf("day"),
    warehouseID,
    outletID,
    moveType: 101,
    moveReasonID: 1,
    selectedIndex: 0,
    openSearchItem: false,
    openBatchValue: false,
    openSearchStock: false,
    openSearchUom: false,
    itemsMovement: [],
  };
  return (
    <Formik
      initialValues={itemsMovementData}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={itemsMovementSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        for (const itemMove of values.itemsMovement) {
          itemMove.qty = parseFloat(itemMove.qty);
          itemMove.unitCost = parseFloat(itemMove.unitCost);
          for (const batchVarValue of itemMove.batchVariantValue) {
            batchVarValue.numberValue = parseFloat(batchVarValue.numberValue);
          }
        }
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Manual Stock Entries ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveItemsMovement(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
        >
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Manual Stock Entries Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <FieldArray name="itemsMovement">
                        {({ push, remove }) => (
                          <React.Fragment>
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="card">
                                  <Table borderless size="sm" responsive="xl">
                                    {values.itemsMovement &&
                                    values.itemsMovement.length > 0 ? (
                                      <thead className="text-center">
                                        <tr>
                                          <th style={{ width: "25%" }}>
                                            Item Name
                                          </th>
                                          <th style={{ width: "5%" }}>
                                            Quantity
                                          </th>
                                          <th style={{ width: "10%" }}>Unit</th>
                                          {values.moveType === 101 ? (
                                            <>
                                              <th>Unit Cost</th>
                                              <th>Production Date</th>
                                              <th>Expiry Date</th>
                                            </>
                                          ) : null}
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                    ) : null}
                                    <tbody>
                                      {values.itemsMovement &&
                                      values.itemsMovement.length > 0 ? (
                                        values.itemsMovement.map(
                                          (item, index) => (
                                            <tr key={index}>
                                              <td>
                                                <FormOutlinedNoMarginTextField
                                                  value={`${item.itemCode} ${item.itemName}`}
                                                  InputProps={{
                                                    startAdornment:
                                                      item.itemType > 0 ? (
                                                        <InputAdornment position="start">
                                                          <BootstrapTooltip
                                                            title={
                                                              item.itemTypeName
                                                            }
                                                          >
                                                            <i
                                                              className={
                                                                item.itemType ===
                                                                1
                                                                  ? "fas fa-boxes text-success"
                                                                  : item.itemType ===
                                                                    2
                                                                  ? "fas fa-tools text-primary"
                                                                  : item.itemType ===
                                                                    3
                                                                  ? "fas fa-building text-info"
                                                                  : item.itemType ===
                                                                    4
                                                                  ? "fas fa-boxes text-warning"
                                                                  : item.itemType ===
                                                                    5
                                                                  ? "fas fa-boxes text-danger"
                                                                  : null
                                                              }
                                                            ></i>
                                                          </BootstrapTooltip>
                                                        </InputAdornment>
                                                      ) : null,
                                                    readOnly: true,
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <FormArrayTextField
                                                  arrayPropName="itemsMovement"
                                                  index={index}
                                                  propName="qty"
                                                  quantityField
                                                  margin="none"
                                                />
                                              </td>
                                              <td>
                                                {values.moveType === 101 ? (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsMovement"
                                                    index={index}
                                                    propName="uomName"
                                                    searchButton
                                                    margin="none"
                                                    readonly
                                                    onSearchClick={() => {
                                                      setFieldValue(
                                                        "selectedIndex",
                                                        index
                                                      );
                                                      setFieldValue(
                                                        "openSearchUom",
                                                        true
                                                      );
                                                    }}
                                                  />
                                                ) : (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsMovement"
                                                    index={index}
                                                    propName="uomName"
                                                    margin="none"
                                                    readonly
                                                  />
                                                )}
                                              </td>
                                              {values.moveType === 101 ? (
                                                <>
                                                  <td>
                                                    <FormArrayTextField
                                                      arrayPropName="itemsMovement"
                                                      index={index}
                                                      propName="unitCost"
                                                      currencyField
                                                      margin="none"
                                                    />
                                                  </td>
                                                  <td>
                                                    <FormArrayDateField
                                                      arrayPropName="itemsMovement"
                                                      index={index}
                                                      propName="productionDate"
                                                    />
                                                  </td>
                                                  <td>
                                                    <FormArrayDateField
                                                      arrayPropName="itemsMovement"
                                                      index={index}
                                                      propName="expiryDate"
                                                    />
                                                  </td>
                                                </>
                                              ) : null}
                                              <td
                                                style={{ whiteSpace: "nowrap" }}
                                                className="text-center"
                                              >
                                                <BootstrapTooltip title="Delete Movement Item">
                                                  <button
                                                    type="button"
                                                    className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                                    onClick={() => {
                                                      setFieldValue(
                                                        "selectedIndex",
                                                        0
                                                      );
                                                      remove(index);
                                                    }}
                                                  >
                                                    <i className="fas fa-trash-alt"></i>
                                                  </button>
                                                </BootstrapTooltip>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            className="text-center py-3"
                                            colSpan={`${
                                              values.moveType === 101
                                                ? "7"
                                                : "4"
                                            }`}
                                          >
                                            <Illustration
                                              imageSource="INVIFO Procurement.png"
                                              guidance="You don't have any Movement items yet"
                                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                              size="sm"
                                            ></Illustration>
                                          </td>
                                        </tr>
                                      )}
                                      <tr>
                                        <td
                                          className="text-center py-3"
                                          colSpan={`${
                                            values.moveType === 101 ? "7" : "4"
                                          }`}
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                            onClick={() => {
                                              if (values.moveType === 101) {
                                                setFieldValue(
                                                  "openSearchItem",
                                                  true
                                                );
                                              } else if (
                                                values.moveType === 102
                                              ) {
                                                setFieldValue(
                                                  "openSearchStock",
                                                  true
                                                );
                                              }
                                            }}
                                          >
                                            <i className="fas fa-plus-circle"></i>
                                            Add Movement Item
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                            <DialogActions>
                              <button
                                type="button"
                                className="btn btn-label-danger btn-md btn-pill btn-bold"
                                onClick={onCloseDialog}
                              >
                                <i className="fas fa-window-close"></i>
                                Close
                              </button>
                              <button
                                type="submit"
                                className="btn btn-success btn-md btn-pill btn-bold"
                              >
                                <i className="fas fa-save"></i>
                                Save
                              </button>
                            </DialogActions>
                            <DialogLayout
                              open={values.openSearchItem}
                              title="Search Item"
                              onCloseDialog={() => {
                                setFieldValue("openSearchItem", false);
                              }}
                              minHeight={true}
                            >
                              <SearchItem
                                tab={tab}
                                selectSellableItems={true}
                                selectServiceItems={false}
                                selectItemPackages={false}
                                selectAssetItems={false}
                                selectVariant={true}
                                onSelectItem={(
                                  item,
                                  itemPackage,
                                  varCode,
                                  valueName
                                ) => {
                                  push({
                                    itemID: item.ID,
                                    itemType: item.itemType,
                                    itemTypeName: item.itemTypeName,
                                    itemCode: item.itemCode,
                                    itemName: item.itemName + " " + valueName,
                                    varCode: varCode,
                                    batchID: 0,
                                    qty: 0,
                                    uomID: item.uomID,
                                    uomName: item.itemUom.uomName,
                                    unitCost: 0,
                                    productionDate: null,
                                    expiryDate: null,
                                    batchVariantValue: [],
                                  });
                                  setFieldValue("openSearchItem", false);
                                }}
                              />
                              <DialogActions>
                                <button
                                  type="button"
                                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                                  onClick={() => {
                                    setFieldValue("openSearchItem", false);
                                  }}
                                >
                                  <i className="fas fa-window-close"></i>
                                  Close
                                </button>
                              </DialogActions>
                            </DialogLayout>
                            <DialogLayout
                              open={values.openBatchValue}
                              title="Batch Value"
                              onCloseDialog={() => {
                                setFieldValue("openBatchValue", false);
                              }}
                              maxWIdth="lg"
                            >
                              {values.itemsMovement[values.selectedIndex] &&
                              values.itemsMovement[values.selectedIndex]
                                .itemID > 0 ? (
                                <SetBatchVariantValue
                                  itemID={
                                    values.itemsMovement[values.selectedIndex]
                                      .itemID
                                  }
                                  batchVariantValueImp={
                                    values.itemsMovement[values.selectedIndex]
                                      .batchVariantValue
                                  }
                                  onConfirmSave={(batchVariantValue) => {
                                    setFieldValue(
                                      `itemsMovement[${values.selectedIndex}].batchVariantValue`,
                                      batchVariantValue
                                    );
                                    setFieldValue("openBatchValue", false);
                                  }}
                                  onCloseDialog={() => {
                                    setFieldValue("openBatchValue", false);
                                  }}
                                />
                              ) : null}
                            </DialogLayout>
                            <DialogLayout
                              open={values.openSearchUom}
                              title="Search Unit of Measurement"
                              onCloseDialog={() => {
                                setFieldValue("openSearchUom", false);
                              }}
                              maxWIdth="sm"
                            >
                              {values.itemsMovement[values.selectedIndex] &&
                              values.itemsMovement[values.selectedIndex]
                                .itemID > 0 ? (
                                <SearchItemUom
                                  itemID={
                                    values.itemsMovement[values.selectedIndex]
                                      .itemID
                                  }
                                  onSelectUom={(uom) => {
                                    setFieldValue(
                                      `itemsMovement[${values.selectedIndex}].uomID`,
                                      uom.ID
                                    );
                                    setFieldValue(
                                      `itemsMovement[${values.selectedIndex}].uomName`,
                                      uom.uomName
                                    );
                                    setFieldValue("openSearchUom", false);
                                  }}
                                />
                              ) : null}
                              <DialogActions>
                                <button
                                  type="button"
                                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                                  onClick={() => {
                                    setFieldValue("openSearchUom", false);
                                  }}
                                >
                                  <i className="fas fa-window-close"></i>
                                  Close
                                </button>
                              </DialogActions>
                            </DialogLayout>
                            <DialogLayout
                              open={values.openSearchStock}
                              title="Search Stock"
                              onCloseDialog={() => {
                                setFieldValue("openSearchStock", false);
                              }}
                              fullScreen={false}
                            >
                              <SearchWarehouseStocks
                                warehouseID={warehouseID}
                                onSelectStock={(stock) => {
                                  push({
                                    itemID: stock.itemID,
                                    itemType: stock.itemType,
                                    itemTypeName: stock.itemTypeName,
                                    itemCode: stock.itemCode,
                                    itemName: stock.itemName,
                                    varCode: stock.varCode,
                                    batchID: stock.batchID,
                                    qty: 0,
                                    uomID: stock.uomID,
                                    uomName: stock.uomName,
                                    unitCost: 0,
                                    productionDate: null,
                                    expiryDate: null,
                                    batchVariantValue: [],
                                  });

                                  setFieldValue("openSearchStock", false);
                                }}
                              />
                              <DialogActions>
                                <button
                                  type="button"
                                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                                  onClick={() => {
                                    setFieldValue("openSearchStock", false);
                                  }}
                                >
                                  <i className="fas fa-window-close"></i>
                                  Close
                                </button>
                              </DialogActions>
                            </DialogLayout>
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default ItemsMovementForm;
